/**
 * Category look (prototype): a soft tint behind product pictures and logos, keyed by category
 * slug or icon name. Gradients for heroes come from the API (`color_from` / `color_to`).
 */
const TINTS: Record<string, string> = {
  textiles: '--t1',
  supermarket: '--t2',
  mobiles: '--t3',
  electronics: '--t3',
  fancy: '--t4',
  footwear: '--t5',
  bakery: '--t6',
  jewellery: '--t6',
  'home-and-kitchen': '--t3',
  home_kitchen: '--t3',
  stationery: '--t2',
}

/** CSS colour for the category tint, e.g. "var(--t1)"; neutral `--t3` when unknown. */
export function tint(slug: string | null | undefined): string {
  return `var(${(slug && TINTS[slug]) || '--t3'})`
}

/** Hero gradient from the API colours, neutral when missing. */
export function categoryGradient(
  c: { color_from: string; color_to: string } | null | undefined,
): string {
  const from = c?.color_from || 'var(--neutral-from)'
  const to = c?.color_to || 'var(--neutral-to)'
  return `linear-gradient(135deg, ${from}, ${to})`
}

/** "Linen Club" → "LC"; brand-mark initials on cards. */
export function brandInitials(brand: string): string {
  return brand
    .split(/[\s-]+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}

/** Brand mark colour token, stable per brand name (prototype's char-code hash). */
export function brandColor(brand: string): string {
  const sum = [...brand].reduce((a, c) => a + c.charCodeAt(0), 0)
  return `var(--bm${(sum % 9) + 1})`
}

/** "VTS Textiles" → "VT" when the API gives no initials. */
export function shopInitials(name: string): string {
  return brandInitials(name) || '?'
}
